export default __webpack_public_path__ + "static/media/game-avatar-blank.ebf843ca.png";